export default __webpack_public_path__ + "static/media/fifteenBooks22.44b7b9a6.jpg";